import React, { useRef, useState, useEffect } from "react";

import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import LockIcon from "@mui/icons-material/Lock";
import EmailIcon from "@mui/icons-material/Email";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Button from "@mui/material/Button";

import { iniciarSesion } from "../../service/apiService";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { InputStyle, MainButton } from "../../SXStyle.jsx";

function Login({ setSnackbar, setFirstTime, setUserEmail}) {

  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  //react-hook-form
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  //react-router-doom
  const navigate = useNavigate();

  //envia el mensaje
  const onSubmit = async (data) => {
    try {
      const response = await iniciarSesion(data);

      //si las credenciales son invalidas
      if (!response.result)
        setSnackbar({ message: response.message, open: true });

      //si no ha cambiado su contraseña temporal
      if (response.data.user.email_verification_date == null) {
        setFirstTime(true);
        setUserEmail(response.data.user.email);
      } 
      else //si ya ha cambiado su password por defecto
      {
        //credenciales validas
        if (response.result) {
          localStorage.setItem("token", response.data.token);
          navigate("/");
        }
      }
    } catch (error) {
      console.log({ error });
      setSnackbar({
        message: "Ocurrió un error inesperado, intente de nuevo",
        open: true,
      });
    }

    //limpia los datos despues de mandar una solicitud
    reset();
  };

  return (
    <div>
      <h1 className="text-xl font-bold leading-tight tracking-tight md:text-2xl text-blanco text-center">
        Iniciar Sesión
      </h1>

      <form
        className="space-y-4 md:space-y-6"
        onSubmit={handleSubmit(onSubmit)}
      >
        <TextField
          required
          id="email"
          label="Correo"
          defaultValue=""
          className="rounded-lg block w-full bg-inputs border"
          sx={InputStyle}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <EmailIcon className="text-amarillo" fontSize="10" />
                </InputAdornment>
              ),
            },
          }}
          error={!!errors.email}
          helperText={errors.email ? "Campo faltante  o inválido" : ""}
          {...register("email", {
            required: true,
            pattern: /^\S+@\S+$/i,
          })}
        />

        <TextField
          required
          type={showPassword ? "text" : "password"}
          id="password"
          label="Contraseña"
          defaultValue=""
          className="rounded-lg block w-full bg-inputs border"
          sx={InputStyle}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <LockIcon className="text-amarillo" fontSize="10" />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment
                  position="start"
                  onClick={handleClickShowPassword}
                  className="cursor-pointer"
                >
                  {showPassword ? (
                    <VisibilityOff className="text-amarillo" fontSize="10" />
                  ) : (
                    <Visibility className="text-amarillo" fontSize="10" />
                  )}
                </InputAdornment>
              ),
            },
          }}
          error={!!errors.password}
          helperText={errors.password ? "Campo faltante" : ""}
          {...register("password", { required: true })}
        />

        <div className="flex items-center justify-between">
          <div className="flex items-start">
            <div className="flex items-center h-5">
              <input
                id="remember"
                aria-describedby="remember"
                type="checkbox"
                className="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-primary-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-primary-600 dark:ring-offset-gray-800"
                required=""
              />
            </div>
            <div className="ml-3 text-sm">
              <label for="remember" className="text-blanco">
                Recordar Contraseña
              </label>
            </div>
          </div>
          <a
            href="/forgot-password"
            className="text-sm font-medium text-blanco font-semibold hover:underline "
          >
            ¿Olvidaste tu contraseña?
          </a>
        </div>

        <Button
          type="submit"
          role={undefined}
          variant="contained"
          sx={MainButton}
        >
          Iniciar Sesión
        </Button>
      </form>
    </div>
  );
}

export default Login;
